import React from 'react';
import { coverDesign, ptToPx } from '../data/designTokens';

// White notch plate pinned to the cover's top-right corner. The shape is the
// Figma export "Vector 377" (289×92, full-width top edge, diagonal cut from
// (0,0) down to (65,92)). The PNO logo renders inside it dark-on-white; the
// Powered-by-AICA wordmark stays in its original top-left cover position.
// Inline path — no network fetch, so the server-export Lambda (which blocks
// network during render) always paints it.
const NOTCH_PATH = 'M289 0H0.5H0L65 92H289V0Z';
const NOTCH_VIEWBOX = '0 0 289 92';

const c = coverDesign;

export const ScreenCoverNotch: React.FC<{ pnoLogoUrl?: string }> = ({ pnoLogoUrl }) => (
    <div
        style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: ptToPx(c.notchWidth),
            height: ptToPx(c.notchHeight),
        }}
    >
        <svg
            width="100%"
            height="100%"
            viewBox={NOTCH_VIEWBOX}
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: 'absolute', inset: 0 }}
        >
            <path d={NOTCH_PATH} fill="#FFFFFF" />
        </svg>
        <div
            style={{
                position: 'relative',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                paddingLeft: ptToPx(c.notchPaddingLeft),
                paddingRight: ptToPx(c.notchPaddingRight),
            }}
        >
            {pnoLogoUrl ? (
                <img
                    src={pnoLogoUrl}
                    alt=""
                    style={{
                        height: ptToPx(c.pnoLogoMaxHeight),
                        width: 'auto',
                        maxWidth: ptToPx(c.pnoLogoMaxWidth),
                        objectFit: 'contain',
                    }}
                />
            ) : null}
        </div>
    </div>
);
